<template>
  <div :class="isLogoSizeChange ? 'logo' : 'company-detail-logo'">
    <img
      :src="logo ? logo : noLogo"
      alt="Company Logo"
      class="img-fit w-100 h-100"
    >
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      default: ""
    },
    isLogoSizeChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noLogo: require("../../../../assets/images/no_logo.png")
    };
  }
};
</script>

<style scoped>
.logo {
  max-width: 70px;
  max-height: 45px;
}
@media screen and (max-width: 767px) {
  .logo {
    max-width: 56px;
    max-height: 36px;
  }
}
.company-detail-logo {
  width: 70px;
  height: 45px;
}
</style>
